import { addDoc } from "firebase/firestore";

/**
 * addDoc for a chat message that may carry `reply_to`.
 *
 * firestore.rules (replyToMatchesReferencedMessage) validates
 * reply_to.sender_name against the referenced message's CURRENT author
 * name. If that name drifted since the message was denormalized, the create
 * is denied; retry once with the rules' neutral "Someone" rather than fail
 * the whole send. Never double-creates: the retry only runs after a rejected
 * first attempt. Mutates `messageData.reply_to` so the returned data matches
 * what was written.
 */
export async function addMessageDocWithReplyFallback(collectionRef, messageData) {
  try {
    return await addDoc(collectionRef, messageData);
  } catch (createError) {
    const canRetryReply =
      createError?.code === "permission-denied" &&
      messageData?.reply_to &&
      messageData.reply_to.sender_name !== "Someone";
    if (!canRetryReply) throw createError;
    messageData.reply_to = { ...messageData.reply_to, sender_name: "Someone" };
    return addDoc(collectionRef, messageData);
  }
}
